module.exports = __webpack_public_path__ + "static/img/bg-en.0d283055.webp";